module.exports = __webpack_public_path__ + "b19b8112082b843ff911339156116d40.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/reading/reading-levels/hard.png
// module id = 2940
// module chunks = 0